/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import { Container, Hidden,} from '@mui/material';
import styled from 'styled-components';

import { Title } from '../Common/Title';
import { CTA } from '../Common/CTA';

const RulesContainer = styled.section`
  padding: 1rem 0;

  .iframeContainer {
    width: 100%;
    height: 720px;
  }
`;

export const Rules = () => {
  const DRAW_RULES_URL = process.env.REACT_APP_S3_URL + 'Regulamento_0202205727_Eskala_-_Sorteio.pdf';
  const VOUCHER_RULES_URL = process.env.REACT_APP_S3_URL + 'Regulamento_0202205733_Eskala_-_Vale-brinde.pdf';

  return (
    <RulesContainer id='rules'>
      <Container>
        <Title>Regulamento do sorteio</Title>
        <Hidden smDown>
          <div className='iframeContainer'>
            <iframe width='100%' height='100%' src={DRAW_RULES_URL} />
          </div>
        </Hidden>
        <Hidden smUp>
          <a href={DRAW_RULES_URL} target='_blank' rel="noreferrer">
            <CTA>Regulamento do sorteio</CTA>
          </a>
        </Hidden>
        <Title mt={8}>Regulamento do vale-brindes</Title>
        <Hidden smDown>
          <div className='iframeContainer'>
            <iframe width='100%' height='100%' src={VOUCHER_RULES_URL} />
          </div>
        </Hidden>
        <Hidden smUp>
          <a href={VOUCHER_RULES_URL} target='_blank' rel="noreferrer">
            <CTA>Regulamento do vale brindes</CTA>
          </a>
        </Hidden>
      </Container>
    </RulesContainer>
  )
}
